/* tslint:disable */
/* eslint-disable */
/* @relayHash 45b35814d8801d324cecd5efa33df288 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FavoritesRootQueryVariables = {
    firmUrlLabel: string;
    isEditMode: boolean;
    isTrade: boolean;
    favoritesPage: number;
};
export type FavoritesRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"FavoritesWrapper_viewer">;
    };
};
export type FavoritesRootQuery = {
    readonly response: FavoritesRootQueryResponse;
    readonly variables: FavoritesRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "firmUrlLabel",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isEditMode",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "favoritesPage",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "urlLabel",
    "variableName": "firmUrlLabel"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "portfoliosInflated",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioV2",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 60
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "favoritesPage"
            }
          ],
          "concreteType": "PortfolioItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "numberOfPages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalResults",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioItemV2",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "item",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Item",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        (v4/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "localizedPdpUrl",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "classification",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemClassification",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "creationDate",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "categories",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemCategory",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "category",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "Category",
                                  "plural": false,
                                  "selections": [
                                    (v5/*: any*/),
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "browseUrl",
                                      "args": null,
                                      "storageKey": null
                                    },
                                    (v1/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "creators",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemCreator",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "attribution",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "creator",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Creator",
                              "plural": false,
                              "selections": [
                                (v6/*: any*/),
                                (v1/*: any*/)
                              ]
                            },
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isArt",
                          "args": null,
                          "storageKey": null
                        },
                        (v7/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "vertical",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "shipmentQuotes",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ShipmentQuote",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "isComplimentary",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "totalAmount",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v9/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "serviceMethod",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ShipmentServiceMethod",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "region",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "Region",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "regionName",
                                      "args": null,
                                      "storageKey": null
                                    },
                                    (v1/*: any*/)
                                  ]
                                },
                                (v1/*: any*/)
                              ]
                            },
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isMultiSku",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "variableAttributes",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "VariableAttribute",
                          "plural": true,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "variableAttributeData",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "VariableAttributeSortType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "swatchSort",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "SwatchSort",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "swatch",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "Swatch",
                                      "plural": false,
                                      "selections": [
                                        (v3/*: any*/),
                                        (v6/*: any*/),
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "name": "imageUrl",
                                          "args": null,
                                          "storageKey": null
                                        },
                                        (v1/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "displayPrice",
                          "storageKey": null,
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isTrade",
                              "variableName": "isTrade"
                            },
                            {
                              "kind": "Literal",
                              "name": "page",
                              "value": "searchAndBrowse"
                            }
                          ],
                          "concreteType": "ItemDisplayPriceType",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "convertedAmountList",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "plural": true,
                              "selections": [
                                (v8/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "currency",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "quantityDisplay",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "percentageOff",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "type",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showPriceLabel",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showPriceVariability",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "quickViewDisplay",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "QuickViewDisplayType",
                          "plural": false,
                          "selections": [
                            (v4/*: any*/),
                            {
                              "kind": "ScalarField",
                              "alias": "mobileTitle",
                              "name": "title",
                              "args": (v10/*: any*/),
                              "storageKey": "title(formatType:\"MOBILE\")"
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "paragraphs",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "QuickViewParagraph",
                              "plural": true,
                              "selections": [
                                (v5/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "text",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": "mobileText",
                                  "name": "text",
                                  "args": (v10/*: any*/),
                                  "storageKey": "text(formatType:\"MOBILE\")"
                                }
                              ]
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "paragraphAttributeNames",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "QuickViewCategorySegments",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "period",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "origin",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "style",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "periodPrefix",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "creators",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "QuickViewCreator",
                              "plural": true,
                              "selections": [
                                (v6/*: any*/),
                                (v7/*: any*/)
                              ]
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "measurement",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemMeasurement",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "display",
                              "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "addLabel",
                                  "value": true
                                },
                                {
                                  "kind": "Literal",
                                  "name": "fields",
                                  "value": [
                                    "height",
                                    "width",
                                    "depth",
                                    "diameter"
                                  ]
                                },
                                {
                                  "kind": "Literal",
                                  "name": "separator",
                                  "value": " "
                                }
                              ],
                              "concreteType": "ItemDisplayMeasurementType",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "unit",
                                  "args": null,
                                  "storageKey": null
                                },
                                (v11/*: any*/)
                              ]
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "size",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemSize",
                              "plural": false,
                              "selections": [
                                (v11/*: any*/)
                              ]
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": "productPhotos",
                          "name": "photos",
                          "storageKey": "photos(limit:1)",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "limit",
                              "value": 1
                            }
                          ],
                          "concreteType": "ItemPhoto",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "placeholder",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "smallPath",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "masterOrZoomPath",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "versions",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemPhotoVersion",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "webPath",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            },
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "firstPhotoWebPath",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "size",
                              "value": "thumb"
                            }
                          ],
                          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "seller",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Seller",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isContemporary",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isCustomizable",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isNewAndMadeToOrder",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "pricing",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemPricing",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "amount",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v9/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "netPrice",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v9/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "salePrice",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v9/*: any*/)
                            }
                          ]
                        },
                        (v1/*: any*/)
                      ]
                    },
                    (v1/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FavoritesRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FavoritesWrapper_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FavoritesRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isEditMode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "tradeFirmsDisplayMode",
                "name": "tradeFirms",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "TradeFirmType",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v12/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isEditMode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "tradeFirmsEditMode",
                "name": "tradeFirms",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "TradeFirmType",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "members",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmMemberType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userId",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ]
                  },
                  (v12/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FavoritesRootQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/FavoritesRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '5ac18cde23e206b83d5d21dce43942b8';
export default node;
